<script>
  import { t9n } from '../../../lib/translate';

  export let headers;
  export let current_group;
</script>

<thead>
<tr class='mdc-data-table__header-row mdc-data-table-bold fade-in'>
  {#each headers as header}
    {#if header.show === true}
      {#if current_group !== 'history'}
        <th
          class='mdc-data-table__header-cell fade-in'
          role='columnheader'
          scope='col'
          style='width: {header.width}'>
          {header.name}
        </th>
      {:else if header.id !== 'header-2'}
        <th
          class='mdc-data-table__header-cell fade-in'
          role='columnheader'
          scope='col'
          style='width: {header.width}'>
          {header.name}
        </th>
      {:else}
        <th
          class='mdc-data-table__header-cell fade-in'
          role='columnheader'
          scope='col'
          style='width: {header.width}'>
          {t9n('order_status_completed')}
        </th>
      {/if}
    {/if}
  {/each}
</tr>
</thead>

<style>
    .mdc-data-table-bold {
        background-color: blanchedalmond;
    }

    @media (max-width: 768px) {

        .mdc-data-table__header-cell {
            display: none;
        }
    }
</style>